import { jsx as r } from "react/jsx-runtime";
import { useOutlet as c } from "../../utils/hooks.js";
const e = "backdrop-outlet";
function n({
  children: t
}) {
  const o = c(e);
  return /* @__PURE__ */ r(o, { children: t });
}
export {
  e as BACKDROP_OUTLET_ID,
  n as BackdropPortal
};
